export default "__VITE_ASSET__BDiIrshQ__"